export default __webpack_public_path__ + "static/media/service5.8725b1ed.jpg";